import { useParams } from 'react-router-dom';
import AppointmentWidget from '@/components/appointment-widget/AppointmentWidget';

/**
 * Public landing page that renders the live booking widget for a given form slug.
 * Used as the "Apri anteprima" target from the embed dialog and as the default
 * URL partners can share with end customers.
 */
export default function BookingPreview() {
  const { slug } = useParams<{ slug: string }>();
  if (!slug) return null;
  return (
    <div style={{ minHeight: '100vh', padding: 24, background: '#f8fafc' }}>
      <div style={{ maxWidth: 960, margin: '0 auto' }}>
        <AppointmentWidget slug={slug} />
      </div>
    </div>
  );
}
